// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ds_top-header_inner2{justify-content:center;height:24px;padding:0,40px,0,40px;background:#5a8fff;line-height:24px;padding:0 40px;color:#fff;font-size:12px}.dosiin-header-sticky{position:fixed;top:0;left:0;width:100%;z-index:12;background:hsla(0,0%,100%,.8);box-shadow:0 4px 8px rgba(16,16,16,.05);-webkit-backdrop-filter:saturate(180%) blur(40px);backdrop-filter:saturate(180%) blur(40px)}", ""]);
// Exports
module.exports = exports;
